import type {CreateExtArgs} from '@wix/document-manager-core'
import type {CompStructure, Pointer} from '@wix/document-services-types'
import {notContainableByPopup} from '../utils/pageUtils'

export const verticalAnchorsMenuMetaData = {
    isRepeatable: false,
    containableByStructure: (createExtArgs: CreateExtArgs, compStructure: CompStructure, containerPointer: Pointer) =>
        notContainableByPopup(createExtArgs, containerPointer)
}
